import {ActionType} from '../enums/action-type.enum';
import {JumpToAction} from '../models/actions/jump-to-action';

export class ActionFactory {
    static CREATE(actionData) {
        switch (actionData.type) {
            case ActionType.JumpTo: {
                return new JumpToAction(actionData.time);
            }
            default: {
                throw new Error('Wrong action type');
            }
        }
    }
}
